import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDoctor } from "../context/DoctorContext";
import { useNotification } from "../context/NotificationContext";
import {
  handleApiResponse,
  handleApiError,
} from "../utils/notificationHelpers";
import Button from "../components/Button";
import "../styles/global.css";
import loginImg from "../assets/LogIn.png";
import authApi from "../apiServices/auth";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { setDoctor } = useDoctor();
  const { notify } = useNotification();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await authApi.login(email, password);

      if (
        handleApiResponse(response, notify, "Login successful", "Login failed")
      ) {
        if (response.data?.access_token) {
          localStorage.setItem("doctorToken", response.data.access_token);
        }
        if (response.data?.doctor) {
          localStorage.setItem(
            "doctorData",
            JSON.stringify(response.data.doctor)
          );
          setDoctor(response.data.doctor);
        }
        navigate("/home");
      }
    } catch (error) {
      handleApiError(error, notify, "login");
    }
  };

  return (
    <div className="flex justify-center gap-10 h-screen bg-[#FEF3E7] padding-x">
      {/* Left Side - Image */}
      <div className="hidden md:flex items-center justify-center md:w-2/5 lg:w-1/2">
        <img
          src={loginImg}
          alt="Login"
          className="max-w-xs md:max-w-md object-contain"
        />
      </div>

      {/* Right Side - Login Form */}
      <div className="w-full md:w-3/5 lg:w-3/5 xl:w-2/5 flex flex-col items-center justify-center xl:p-2 bg-white shadow-lg">
        <img
          src="/Logo.png"
          alt="Logo"
          className="w-16 md:w-20 lg:w-24 mx-auto mb-12 md:mb-16"
        />
        <h2 className="text-4xl md:text-3xl xl:text-4xl font-bold mb-14">
          Log In
        </h2>

        <form className="w-full px-6" onSubmit={handleLogin}>
          <div className="mb-10">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full px-3 py-2.5 border border-black rounded-md focus:ring-2 focus:ring-orange-500 placeholder:text-gray-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-2">
            <input
              type="password"
              placeholder="Enter your password"
              className="w-full px-3 py-2.5 border border-black rounded-md focus:ring-2 focus:ring-orange-500 placeholder:text-gray-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="text-right font-medium text-gray-900 mb-4">
            <Link to="/forgot-password" className="hover:underline">
              Forgot password?
            </Link>
          </div>

          <Button text="Log In" className="mt-2 w-full" type="submit" />
        </form>
      </div>
    </div>
  );
};

export default Login;
